import React from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { colorOpacity, customTheme } from 'theme';

import { formatTooltip } from 'components/DataDisplay';
import formatNumber from 'components/DataDisplay/Utils/formatNumber';
import { ServerIcon } from 'components/Icons';
import { selectDashboard } from 'containers/Dashboard/selectors';
import { SummaryCard } from 'containers/Dashboard/utils/SummaryCard';
import { getSumOfValues } from 'containers/Dashboard/utils/utils';

export const ComputeEntities: React.FC = () => {
  const {
    infrastructurePostureSummary,
    computeCount,
    machinesStopped,
  } = useSelector(selectDashboard);
  const { data, isLoading } = infrastructurePostureSummary;
  const navigate = useNavigate();

  return (
    <SummaryCard
      label="Compute"
      icon={<ServerIcon />}
      change={{
        isLoading: false,
        first: computeCount.data.previous_count ?? 0,
        last: computeCount.data.current_count ?? 0,
        percentChange: computeCount.data?.percentage_change ?? 0,
      }}
      cloudProviders={data?.items?.['ProvidersByLabel']?.['Compute']}
      count={getSumOfValues(data?.items?.['Compute'])}
      isLoading={isLoading}
      info={{
        message:
          formatNumber(machinesStopped?.data?.stopped || 0) +
          ' machines stopped',
        bg: colorOpacity(customTheme.colors.primary, 0.3),
        isLoading: machinesStopped.isLoading,
      }}
      onClick={() => navigate('/inventory/cloud?resource_category=Compute')}
      showPercentChange={true}
      labelTooltip={formatTooltip({
        header: 'Compute',
        content: 'Compute resources in public clouds',
      })}
    />
  );
};
